import { useEffect } from 'react'
import { gql, useMutation } from '@apollo/client'
import { useAuth } from 'lib/auth'
import useQueryString from 'lib/hooks/use-query-string'

export const COACH_CAMPAIGN_PARAM = 'cc'

export const RECORD_COACH_CAMPAIGN_VISIT = gql`
  mutation RecordCoachCampaignVisit($token: String!) {
    recordCoachCampaignVisit(token: $token) {
      success
      message
    }
  }
`

// Campaign booking links carry `?cc=<token>`. Recording the visit marks the
// student's next booking with the coach as a direct campaign conversion. This
// is not behind the campaigns flag: the flag targets coaches, and students
// who open a sent campaign's link must still be attributed.
export default function useRecordCoachCampaignVisit() {
  const { [COACH_CAMPAIGN_PARAM]: token } = useQueryString()
  const { isConsumer } = useAuth()
  const [recordVisit] = useMutation(RECORD_COACH_CAMPAIGN_VISIT, {
    onError: () => {},
  })

  useEffect(() => {
    if (isConsumer && typeof token === 'string' && token) {
      recordVisit({ variables: { token } })
    }
  }, [isConsumer, token, recordVisit])
}
